import { buildFighterKey } from '../../domain/utils/fighterImage.utils';
import { Action } from '../action.type';
import { AppState } from '../app.state';
import {
  RetrieveFighterImagePayload,
  RetrieveFighterImageSuccessPayload,
  RETRIEVE_FIGHTER_IMAGE,
  RETRIEVE_FIGHTER_IMAGE_FAILURE,
  RETRIEVE_FIGHTER_IMAGE_SUCCESS,
} from './image.action.type';

export const imageReducer = (
  state: AppState,
  action: Action<any>,
): AppState => {
  switch (action.type) {
    case RETRIEVE_FIGHTER_IMAGE:
      return retrieveFighterImageReducer(state, action);
    case RETRIEVE_FIGHTER_IMAGE_SUCCESS:
      return retrieveFighterImageSuccessReducer(state, action);
    case RETRIEVE_FIGHTER_IMAGE_FAILURE:
      return retrieveFighterImageFailureReducer(state, action);
    default:
      return state;
  }
};

const retrieveFighterImageReducer = (
  state: AppState,
  action: Action<RetrieveFighterImagePayload>,
): AppState => {
  const { firstName, lastName, dob } = action.payload;
  const imagePath = buildFighterKey(firstName, lastName, dob);

  if (!imagePath) {
    return state; // No valid key, return unchanged state
  }

  const newLoadingImages = {
    ...state.image.loadingImages,
    [imagePath]: true,
  };

  return {
    ...state,
    image: {
      ...state.image,
      loadingImages: newLoadingImages,
      isLoading: Object.values(newLoadingImages).some((loading) => loading), // Derive global loading
    },
  };
};

export const retrieveFighterImageSuccessReducer = (
  state: AppState,
  action: Action<RetrieveFighterImageSuccessPayload>,
): AppState => {
  const { imagePath } = action.payload;

  const newLoadingImages = {
    ...state.image.loadingImages,
    [imagePath]: false,
  };

  const newFighterImages = {
    ...state.image.fighterImages,
    [imagePath]: action.payload.image,
  };

  return {
    ...state,
    image: {
      ...state.image,
      fighterImages: newFighterImages,
      loadingImages: newLoadingImages,
      isLoading: Object.values(newLoadingImages).some((loading) => loading), // Derive global loading
    },
  };
};

export const retrieveFighterImageFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  // For failure, we need to clear all loading states since we don't know which specific image failed
  // This is a limitation of the current error handling - ideally we'd pass the imagePath in the error
  return {
    ...state,
    image: {
      ...state.image,
      loadingImages: {}, // Clear all loading states on error
      error: action.payload,
      isLoading: false,
    },
  };
};
